import type { PropId } from "./props";

/**
 * Room decor and trinkets from Molly's Temu orders: candles, misters, towels,
 * perfumes and the like, cut out of the shop's product photos. They're in the
 * catalogue on their own shelf, and start out of every room, the palace
 * included, until they're put in.
 */
export const DECOR: PropId[] = [
  "decor-angel-candle",
  "decor-soy-candle",
  "decor-plant-mister-blue",
  "decor-plant-mister-mint",
  "decor-plant-mister-pink",
  "decor-angel-candle-lilac",
  "decor-carved-bell",
  "decor-fruit-towels",
  "decor-strawberry-towel",
  "decor-heart-towels",
  "decor-taper-candles",
  "decor-crystal-roses",
  "decor-cupid-candle-blue",
  "decor-cupid-candle-pink",
  "decor-pocket-watch",
  "decor-moon-kiss-art",
  "decor-glass-mister",
  "decor-crystal-prism",
  "decor-tissue-box-blue",
  "decor-botanical-postcards",
  "decor-flower-perfume",
  "decor-strawberry-glass",
  "decor-strawberry-molds",
  "decor-cherry-umbrella",
  "decor-strawberry-soaps",
  "decor-perfume-amber",
  "decor-perfume-bow",
  "decor-perfume-dreamland",
  "decor-heart-gift-box",
  "decor-perfume-pink",
  "can_watering_garden_metal_blush_pink_sticker",
  "mister_plant_spray_bottle_embossed_glass_ombre_turquoise_pink_antique_sticker",
];

/** trinkets and a plant added later: on the Trinkets and House plants shelves,
    not Room decor, but out of every room at first like the decor */
export const MORE_TRINKETS: PropId[] = [
  "decor-pink-gilt-box",
  "decor-jade-buddha",
  "decor-stone-deity-head",
  "decor-gilt-bell",
  "decor-green-glass-insulator",
  "decor-pink-glass-jar",
  "decor-ivy-bottle",
  "bottle_glass_jar_embossed_aqua_vintage_sticker",
  "suncatcher_stained_glass_hanging_scalloped_floral_turquoise_sticker",
  "suncatcher_crystal_prisms_gold_moon_sun_hanging_sticker",
  "suncatcher_crystal_hummingbird_prism_hanging_sticker",
  "suncatcher_crystal_rose_quartz_gold_prism_hanging_sticker",
  "caddy_shower_hanging_wire_three_tier_blue_sticker",
  "canister_jadeite_glass_lidded_cocoa_sticker",
  "canister_jadeite_glass_lidded_sugar_sticker",
  "canister_jadeite_glass_lidded_rosemary_sticker",
  "artwork_print_art_nouveau_girl_crown_green_giantess_sticker",
  "book_madeleine_ludwig_bemelmans_hardcover_sticker",
  "pomegranate_glass_red_gold_stem_sticker",
  "dish_jadeite_glass_rabbit_on_nest_covered_sticker",
  "tree_jadeite_glass_christmas_large_sticker",
  "tree_jadeite_glass_christmas_small_sticker",
  "peacock_bird_standing_trailing_tail_sticker",
  "mirror_wall_arch_ornate_gold_vintage_sticker",
  "mirror_wall_oval_ornate_gold_crest_vintage_sticker",
  "telescope_refractor_tripod_navy_blue_meade_sticker",
  "telescope_refractor_tripod_navy_blue_meade_facing_left_sticker",
  "dresser_walnut_mid_century_drawers_tapered_legs_sticker",
  "wardrobe_antique_mahogany_mirror_door_drawers_sticker",
  "sofa_sectional_chaise_slipcover_grey_rolled_arms_sticker",
  "sofa_sectional_chaise_slipcover_grey_rolled_arms_angled_left_sticker",
  "sofa_sectional_chaise_slipcover_grey_rolled_arms_angled_chaise_right_sticker",
  "sofa_sectional_chaise_slipcover_grey_rolled_arms_side_view_sticker",
  "saxophone_alto_brass_vintage_gold_sticker",
  "hat_propeller_noogler_blue_yellow_red_green_sticker",
  "ghost_sheet_navy_bow_books_candlestick_sticker",
  "computer_imac_purple_back_view_sticker",
  "computer_imac_g3_lime_green_keyboard_mouse_sticker",
  "computer_imac_g3_lime_green_front_facing_sticker",
  "lamp_bankers_desk_green_glass_shade_brass_pull_chain_sticker",
  "character_molly_sticker",
  "character_kate_sticker",
  "character_leonardo_sticker",
  "character_brea_sticker",
  "character_madeleine_sticker",
  "character_moselle_sticker",
  "character_kayenat_sticker",
  "character_ella_sticker",
  "character_sarah_sticker",
  "character_stephanie_sticker",
  "character_jonathan_sticker",
  "character_dream_sticker",
  "character_bryan_sticker",
  "character_jessica_sticker",
  "character_peter_sticker",
  "character_jordan_sticker",
  "character_destiny_sticker",
  "character_jericha_sticker",
  "character_jerusha_sticker",
  "character_alisha_sticker",
  "character_jeannette_sticker",
  "character_chade_sticker",
  "snail_giant_african_land_shell_sticker",
  "snail_giant_african_land_shell_facing_left_sticker",
  "snail_giant_vicious_fanged_spiked_facing_left_sticker",
  "snail_giant_vicious_fanged_spiked_sticker",
  "snail_giant_vicious_eating_a_man_sticker",
  "road_case_vintage_mail_stack_black_sticker",
  "rabbit_black_bow_tie_sitting_sticker",
  "dog-leo-dalmatian",
  "jackrabbit_desert_black_tailed_standing_sticker",
  "tortoise_desert_walking_sticker",
  "fox_kit_desert_standing_sticker",
  "roadrunner_desert_running_sticker",
  "ocotillo_agave_cluster_flowering_red_sticker",
  "cactus_golden_barrel_agave_cluster_sticker",
  "cactus_prickly_pear_cluster_fruiting_sticker",
  "cactus_saguaro_cholla_desert_cluster_sticker",
  "artwork_framed_abstract_splatter_painting_blue_green_gold_frame_sticker",
  "artwork_framed_abstract_pour_painting_pink_blue_black_gold_frame_sticker",
  "radiator_heater_cast_iron_ribbed_white_vintage_sticker",
  "shelf_rack_garden_three_tier_scrollwork_glass_white_sticker",
  "bottle_glass_embossed_decanter_peach_pink_vintage_sticker",
  "flute_glass_champagne_tall_cobalt_blue_sticker",
  "goblet_glass_wine_aqua_turquoise_sticker",
  "bottle_glass_gin_sealed_green_vintage_sticker",
  "bottle_candle_holder_dripping_wax_cobalt_blue_sticker",
  "bottle_vase_lowell_embossed_pothos_cutting_green_glass_antique_sticker",
  "bottle_candle_holder_embossed_dripping_wax_red_pink_sticker",
  "bottle_vase_pothos_cutting_embossed_green_glass_sticker",
  "bottle_perfume_crystal_stopper_enamel_floral_purple_vintage_sticker",
  "brush_makeup_rose_enamel_leaves_gold_sticker",
  "planter_hanging_macrame_woven_basket_string_of_pearls_sticker",
  "box_trinket_round_portrait_cream_gold_vintage_sticker",
  "lamp_aladdin_genie_pink_enamel_gold_jeweled_sticker",
  "candle_cherub_angel_seated_pastel_blue_sticker",
  "box_incense_burner_wood_lattice_moon_stars_brass_sticker",
  "bottle_dropper_apothecary_glass_emerald_green_sticker",
  "jar_trinket_cut_glass_lidded_blush_pink_sticker",
  "box_trinket_jasperware_cameo_powder_blue_sticker",
  "plant_snake_sansevieria_white_pot_sticker",
  "candle_cherub_angel_seated_mint_green_sticker",
  "bottle_glass_embossed_medallion_dusty_rose_pink_sticker",
  "candlestick_ornate_drip_candle_mint_green_sticker",
  "planter_pot_embossed_floral_medallion_off_white_sticker",
  "planter_pot_hand_painted_purple_flowers_saucer_sticker",
  "candlestick_glass_bubble_stem_green_taper_ivory_sticker",
  "cup_vanity_pressed_glass_amber_perfume_tubes_sticker",
  "tray_trinket_porcelain_gilt_medallion_cobalt_blue_sticker",
  "box_incense_burner_wood_lattice_moon_stars_upright_sticker",
  "coffee_maker_drip_smeg_retro_pink_sticker",
  "espresso_machine_smeg_retro_cream_sticker",
  "microwave_insignia_retro_mint_teal_sticker",
  "stove_range_smeg_victoria_lavender_sticker",
  "cabinet_china_peach_pink_jadeite_pink_depression_glass_sticker",
  "dresser_five_drawer_light_oak_scalloped_gold_pulls_sticker",
  "shelf_wall_geometric_diamond_gold_frame_three_tier_white_sticker",
  "shelf_wall_long_trailing_pothos_watering_can_column_fairy_lights_sticker",
  "shelf_wall_long_pothos_teacups_string_of_pearls_fairy_lights_sticker",
  "shelf_corner_ivy_green_bottle_teacup_fairy_lights_sticker",
  "shelf_corner_pothos_basket_red_bottle_fairy_lights_sticker",
  "garland_ivy_vine_fairy_lights_sticker",
  "artwork_framed_line_drawing_woman_braids_black_white_sticker",
  "box_trinket_octagonal_cobalt_blue_gold_roses_sticker",
  "candlestick_glass_olive_green_lit_ivory_candle_left_sticker",
  "candlestick_glass_olive_green_lit_ivory_candle_right_sticker",
  "book_the_game_changing_attorney_michael_mogill_sticker",
  "book_hot_girl_crochet_rose_svane_sticker",
  "book_world_travel_anthony_bourdain_sticker",
  "book_hundred_years_war_on_palestine_rashid_khalidi_sticker",
  "book_grc_engineering_for_aws_aj_yawn_sticker",
  "tin_tarot_golden_art_nouveau_sticker",
  "wall_pocket_porcelain_violets_gold_trim_sticker",
  "stool_strawberry_red_glazed_sticker",
  "sofa_sectional_chaise_blush_pink_pillows_sticker",
  "rug_floral_tufted_grey_multicolour_flowers_sticker",
  "vanity_oak_scalloped_round_mirror_sticker",
  "cabinet_apothecary_cream_many_drawers_novelty_knobs_sticker",
  "bed_french_cream_cherry_print_pink_bedding_sticker",
  "artwork_framed_print_woman_blue_leaves_sticker",
  "artwork_framed_print_red_poppies_pink_sticker",
  "shelf_wall_picture_ledge_oak_vinyl_records_hers_mitski_top_sticker",
  "shelf_wall_picture_ledge_oak_vinyl_records_puberty_be_the_cowboy_bottom_sticker",
  "rug_cat_tufted_peach_flowers_sticker",
  "artwork_framed_vogue_cover_art_deco_sticker",
  "book_the_game_changing_attorney_michael_mogill_hardcover_sticker",
  "book_hot_girl_crochet_rose_svane_hardcover_sticker",
  "book_world_travel_anthony_bourdain_hardcover_sticker",
  "ornament_reflector_rounded_magenta_sticker",
  "ornament_teardrop_frosted_glitter_orange_sticker",
  "ornament_ball_hand_painted_red_flower_silver_sticker",
  "ornament_grape_cluster_purple_sticker",
  "ornament_ball_pink_ribbon_bow_turquoise_sticker",
  "ornament_pinecone_quilted_pink_sticker",
  "ornament_ball_painted_leaf_red_sticker",
  "ornament_grape_cluster_cobalt_blue_sticker",
  "ornament_reflector_saucer_silver_sticker",
  "ornament_finial_onion_glitter_stripes_green_silver_large_sticker",
  "ornament_ball_reflector_magenta_large_sticker",
  "ornament_pickle_glass_lime_green_sticker",
  "ornament_santa_claus_glass_pink_sticker",
  "ornament_ball_painted_stripes_red_green_silver_sticker",
  "ornament_ball_turquoise_small_sticker",
  "ornament_santa_claus_red_pink_ribbon_sticker",
  "ornament_ball_shiny_purple_sticker",
  "ornament_berry_cluster_red_sticker",
  "ornament_ball_worn_silver_blue_spots_sticker",
  "ornament_finial_onion_glitter_stripes_green_silver_small_sticker",
  "ornament_strawberry_frosted_coral_red_sticker",
  "ornament_ball_reflector_magenta_small_sticker",
  "ornament_strawberry_small_red_sticker",
  "cat-petunia",
  "tree_christmas_decorated_presents_sticker",
  "artwork_print_woman_moka_pot_line_black_white_sticker",
  "artwork_framed_magazine_cover_deco_yellow_sticker",
  "vase_cat_pink_ceramic_trailing_plant_sticker",
  "cookbook_recipes_red_gilt_closed_sticker",
  "book_cookbook_open_recipes_sticker",
  "book_everybodys_story_loyal_rue_hardcover_sticker",
  "book_everybodys_story_loyal_rue_lying_down_sticker",
  "poster_lillebaeltsbroen_bridge_denmark_vintage_sticker",
  "poster_danish_composer_pianist_portrait_vintage_sticker",
  "pool_table_retro_walnut_green_felt_sticker",
  "wine_la_boheme_act_one_yarra_valley_white_bottle_sticker",
  "wine_la_boheme_act_two_yarra_valley_rose_bottle_sticker",
  "mandarins_cuties_organic_mesh_bag_sticker",
  "mandarins_halos_mesh_bag_sticker",
  "synthesizer_keyboard_yamaha_cream_sticker",
  "sticker_maker_create_a_sticker_mini_pink_lime_sticker",
  "book_no_one_belongs_here_more_than_you_miranda_july_sticker",
  "book_no_one_belongs_here_more_than_you_miranda_july_lying_down_sticker",
  "book_witchy_moon_phases_purple_galaxy_clasp_sticker",
];

/** everything that starts out of the rooms and is set out along the terrace's front */
export const LOOSE: PropId[] = [...DECOR, ...MORE_TRINKETS];

export const DECOR_SET = new Set<string>(LOOSE);
